import * as React from 'react'

import { ArrowLeft, Share2, Trash2 } from 'lucide-react'
import { action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'

import { CustomFilterDialogModes } from '~/client/src/shared/enums/CustomFilterDialogModes'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import DesktopDeliverySavedFiltersStore from '../DeliverySavedFilters/DesktopDeliverySavedFilters.store'
import SectionButton, { ISavedFiltersSection } from './components/SectionButton'
import DesktopSavedFiltersStore from './DesktopSavedFilters.store'

// localization: translated

interface IProps {
  desktopSavedFiltersStore:
    | DesktopSavedFiltersStore
    | DesktopDeliverySavedFiltersStore
}

@observer
export default class SavedFiltersHeader extends React.Component<IProps> {
  private sections: ISavedFiltersSection[] = [
    {
      getLabel: () => Localization.translator.share,
      icon: <Share2 data-icon="inline-start" />,
      onClick: this.clickOnShare.bind(this),
      isDisabled: true,
    },
    {
      getLabel: () => Localization.translator.delete,
      icon: <Trash2 data-icon="inline-start" />,
      onClick: this.clickOnDelete.bind(this),
    },
  ]

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const { filterDialogMode: mode, toggleSaveFilterDialog } =
      this.props.desktopSavedFiltersStore

    const isEditMode = mode === CustomFilterDialogModes.Edit

    const headerCapture = isEditMode
      ? Localization.translator.editACustomFilter
      : Localization.translator.saveANewCustomFilter
    return (
      <div className="tw:flex tw:items-center px10 mt5 mb10">
        <div
          className="tw:flex tw:items-center pl5 pointer"
          onClick={toggleSaveFilterDialog}
        >
          <ArrowLeft className="tw:size-5" />
          <div className="ml10 text extra-large">{headerCapture}</div>
        </div>
        {isEditMode &&
          this.sections.map((section, index) => (
            <SectionButton key={index} section={section} />
          ))}
      </div>
    )
  }

  @action.bound
  private clickOnShare() {
    // TODO: Implement logic to share custom filter
  }

  @action.bound
  private clickOnDelete() {
    const { deleteCustomFilter } = this.props.desktopSavedFiltersStore as any
    deleteCustomFilter?.()
  }
}
